﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const form_controls_1 = require("@its-suite/form-controls");
const Password_1 = require("../Password");
class PinFields extends React.Component {
    constructor(props) {
        super(props);
        this.renderPinField = (name, label, value, validators) => {
            return this.getPinField(name, label, value, validators);
        };
        this.getPinField = (name, label, value, validators) => {
            return (React.createElement("div", null,
                React.createElement(Password_1.PasswordField, { name: name, label: label, value: value, prefixId: this.props.prefixId, onChange: this.props.onChange, onFocus: this.props.onFocus, validators: validators, disabled: this.props.disabled, className: this.props.className, autoComplete: 'off' })));
        };
        this.state = {
            pin: '',
            pinConfirmation: ''
        };
        this.pinValidator = PinFields.getPINValidator(this.props.texts.pinErrorMessage);
        this.pinConfirmationValidator = new form_controls_1.Validator({
            validatorType: form_controls_1.ValidatorTypes.Custom,
            message: this.props.texts.pinConfirmationError,
            validatorName: 'PINValidator'
        });
    }
    static getPINValidator(message) {
        const validatorName = 'pinValidator';
        form_controls_1.ValidatorForm.addValidationRule(validatorName, (value) => PinFields.validatePIN(value));
        return new form_controls_1.Validator({
            validatorType: form_controls_1.ValidatorTypes.Custom,
            validatorName: validatorName,
            message: message
        });
    }
    static validatePIN(pin) {
        const pinRegex = /^[0-9]{4}$/;
        return !pin || !!pin.match(pinRegex);
    }
    componentDidMount() {
        form_controls_1.ValidatorForm.addValidationRule('PINValidator', confirmationPin => confirmationPin === this.props.pinValue);
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.renderPinField('pin', this.props.texts.pin, this.props.pinValue, [this.pinValidator]),
            this.renderPinField('pinConfirmation', this.props.texts.pinConfirmation, this.props.pinConfirmationValue, [this.pinValidator, this.pinConfirmationValidator])));
    }
}
exports.PinFields = PinFields;
//# sourceMappingURL=PinFields.js.map